import React from 'react';
import { Zap } from 'lucide-react';

interface LogoProps {
  className?: string;
}

const Logo: React.FC<LogoProps> = ({ className = "" }) => {
  return (
    <div className={`flex items-center gap-2 ${className}`}>
      <Zap className="w-8 h-8 text-yellow-500" />
      <div className="font-bold leading-tight">
        <div className="text-lg">Electricista</div>
        <div className="text-yellow-500 text-sm">24h</div>
      </div>
    </div>
  );
};

export default Logo;